import { useSelector } from 'react-redux';
import { compareOnTrendsFiltersSelector } from '@store/trends/base/selectors';
import useTimeseriesQuery from './useTimeseriesQuery';
import { getFirstAppliedFilter } from '@store/common/selectors';
import { getFilterFromRules, getRulesFromFilter } from '@utils';
import update from 'immutability-helper';
import { useMemo } from 'react';
import useSecondaryQuery from './secondary/useSecondaryQuery';

function useCompareTimeseriesQueries(useQueryTemplate = useTimeseriesQuery) {
  const { query: baseQuery, interval, metrics, realTimeOnTrends } = useQueryTemplate();
  const compareFilters = useSelector(compareOnTrendsFiltersSelector);
  const baseFilter = useSelector(getFirstAppliedFilter);

  const queries = useMemo(() => {
    return compareFilters.map((filter) => {
      // combine with parent filter
      const subFilter = update(baseFilter.rule, {
        $push: [...filter.rule],
      });
      const allRules = getRulesFromFilter(subFilter, true);
      const filterToApply = getFilterFromRules(allRules, true);

      return {
        ...baseQuery,
        filter: filterToApply.rule,
      };
    });
  }, [baseQuery, compareFilters, baseFilter]);

  return { queries, interval, metrics, compareFilters, realTimeOnTrends };
}

export function useSecondaryCompareTimeseriesQueries() {
  const params = useCompareTimeseriesQueries(useSecondaryQuery);
  return params;
}

export default useCompareTimeseriesQueries;
